<script>export let input = null;
export let index;
export let value;
export let codes;
export let inputs;
export let nostyle;
export let className;
export let num;
export let style;
export let placeholder;
export let autofocus;
let key;
function shiftFocus(key2) {
  if (!/[0-9]/.test(key2) && num && key2 || key2 === "ArrowRight" || key2 === "ArrowLeft" || key2 === "Backspace")
    return;
  if (value === " ") {
    value = "";
    return;
  }
  if (index !== inputs.length - 1)
    inputs[index + 1].focus();
}
function keyDownHandler(e) {
  if (e.ctrlKey && e.key === "z") {
    e.preventDefault();
  }
  key = e.key;
  if (value.length >= 1 && !e.ctrlKey)
    shiftFocus(key);
}
function typeHandler(e) {
  if (value.length >= 1 || !/[0-9]/.test(e.key) && num) {
    e.preventDefault();
  }
}
function changeHandler(e) {
  const val = e.target.value;
  if (/[0-9]/.test(val) || !num || !val) {
    codes = codes.map((c, i) => {
      if (i < index) {
        return c === "" ? " " : c;
      } else if (i === index) {
        return val[0];
      }
      return c;
    });
    if (!val) {
      const len = codes.length;
      const filtered = codes.filter((_, i) => i !== index);
      codes = [...filtered, ...Array(len - filtered.length).fill("")];
    }
    shiftFocus(key);
  }
}
function keyUpHandler(e) {
  if ((e.key === "Backspace" || e.key === "ArrowLeft") && index !== 0) {
    inputs[index - 1]?.focus();
  } else if (e.key === "ArrowRight" && index !== inputs.length - 1) {
    inputs[index + 1]?.focus();
  }
}
function pasteHandler(e) {
  e.preventDefault();
  const paste = e.clipboardData?.getData("text");
  if (!paste)
    return;
  let pasteValue = paste.replace(num ? /[^0-9]/g : "", "").slice(0, codes.length - index);
  const newCodes = [
    ...codes.slice(0, index),
    ...pasteValue.split(""),
    ...codes.slice(index + pasteValue.length)
  ];
  codes = newCodes;
}
</script>

<!-- svelte-ignore a11y-autofocus -->
<input
	{autofocus}
	class={`${nostyle ? '' : 'default-input'} ${className}`}
	bind:this={input}
	on:keydown={keyDownHandler}
	on:keyup={keyUpHandler}
	on:keypress={typeHandler}
	on:input={changeHandler}
	on:paste={pasteHandler}
	{style}
	{value}
	{placeholder}
	pattern="{num ? "[0-9]*" : ""}"
/>

<style>
	.default-input {
		width: 30px;
		height: 40px;
		text-align: center;
		border: 1px solid black;
		margin: 0;
	}
</style>
